import { t } from 'i18next';
import { toast } from 'react-toastify';

export const trySendFullfilledMessage = (i18KeyPrefix: string, endpointName: string): boolean => {
  const key = `${i18KeyPrefix}.${endpointName}`;
  const message = t(key);
  if (key !== message) {
    toast.success(message, { toastId: key });
    return true;
  }
  return false;
};
export const trySendRejectedMessage = (i18KeyPrefix: string, endpointName: string, value = {}): boolean => {
  const key = `${i18KeyPrefix}.${endpointName}`;
  const message = t(key, value) as string;

  if (key !== message) {
    toast.error(message, { toastId: key });
    return true;
  }
  return false;
};
